module.exports = __webpack_public_path__ + "static/media/clicker-hand-icon.bab40b08.png";